import Vue from 'vue';
import RTCPeer from './rtc-peer.js';
import WSPeer from './ws-peer.js';
import {rtcSupported} from './utils.js';
import eventBus from '../event-bus.js';


const {store} = Vue;


export default class PeersManager {


  constructor(serverConnection) {
    this.peers = {};
    this._server = serverConnection;

    this._unsubscribe = store.subscribe(({type, payload}) => {
      if (type === 'share/setPeers') {
        this._onPeers(payload);

      } else if (type === 'share/removePeer') {
        this._onPeerLeft(payload);
      }
    });

    serverConnection.socket.on('signal', (message) => this._onMessage(message));

    this._sendFilesListener = (data) => {
      try {
        this._onSendFiles(data);
        data.resolve?.();
      } catch (error) {
        data.reject?.(error);
      }
    };

    this._sendTextListener = (data) => {
      try {
        this._onSendText(data);
        data.resolve?.();
      } catch (error) {
        data.reject?.(error);
      }
    };

    eventBus.$on('sendFiles', this._sendFilesListener);
    eventBus.$on('sendText', this._sendTextListener);

    this._beforeunloadListener = (e) => {
      const busyPeers = !!store.getters['share/getPeersBusy'].length;
      const unsavedFiles = !!store.getters['share/getUnsavedFiles'].length;
      if (busyPeers || unsavedFiles) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    this._unloadListener = () => {
      for (const peer of Object.values(this.peers)) {
        peer.remove('room_left');
      }
    };

    window.addEventListener('beforeunload', this._beforeunloadListener);
    window.addEventListener('unload', this._unloadListener);
  }


  close() {
    this._unsubscribe();
    eventBus.$off('sendFiles', this._sendFilesListener);
    eventBus.$off('sendText', this._sendTextListener);
    window.removeEventListener('beforeunload', this._beforeunloadListener);
    window.removeEventListener('unload', this._unloadListener);
  }


  _onMessage(message) {
    const peerId = message.sender;
    let peer = this.peers[peerId];
    if (!peer) {
      // NOTE: Do not add peerId as second parameter
      peer = this.peers[peerId] = new RTCPeer(this._server);
    }

    peer.onServerMessage(message);
  }


  _onPeers(peers) {
    // Remove all peers
    Object.keys(this.peers).forEach((peerId) => this._onPeerLeft(peerId));

    for (const peer of peers) {
      if (this.peers[peer.id]) {
        this.peers[peer.id].refresh();
        continue;
      }
      if (rtcSupported && peer.rtcSupported) {
        this.peers[peer.id] = new RTCPeer(this._server, peer.id);
      } else {
        this.peers[peer.id] = new WSPeer(this._server, peer.id);
      }
    }
  }


  _onSendFiles({to, files, description}) {
    this.peers[to].sendFiles(files, description);
  }


  _onSendText({to, text}) {
    this.peers[to].sendText(text);
  }


  _onPeerLeft(peerId) {
    const peer = this.peers[peerId];
    if (!peer) {
      return;
    }

    peer.remove();
    delete this.peers[peerId];
  }
}
